import { render } from "./App.vue?vue&type=template&id=39851472"
const script = {}

import "./App.vue?vue&type=style&index=0&id=39851472&lang=scss"
script.render = render

export default script